import React from 'react';

function PowerStripUsb() {
  return (
    <svg width={64} height={64} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62 12H2v15h60V12Zm-.938 11H2.938v3h58.124v-3ZM62 37H2v15h60V37Zm-.938 11H2.938v3h58.124v-3Z"
        fill="#82D1AD"
      />
    </svg>
  );
}

export default PowerStripUsb;
